import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/core/services/alert.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { environment } from 'src/environments/environment';
import { CartModuleConsts } from '../../contants';
import { CartService } from '../../services/cart.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SharedConsts } from 'src/app/shared/constants';
import { select, Store } from '@ngrx/store';
import { SharedState } from 'src/app/shared/store/reducers';
import { getConfig } from 'src/app/shared/store/selectors/shared.selectors';
import { loadCheckoutWebComponents } from '@checkout.com/checkout-web-components'
import { LoaderService } from 'src/app/shared/loader/loader.service';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})
export class PaymentComponent implements OnInit {
// new varible added for new flow
  cardComponent: any;
  checkoutEngine: any;
  isFormValid: boolean = false; 
  isFormRendered = false; 


  flowComponent: any;
  isPaymentLoading = false;
  paymentSessionId:any = null;;
  publicKey='';
  wantsToSaveCard: boolean = false
  status: boolean = false;
  redirectUrl:any;
  public windowUrl: any;
  bsModalRef: BsModalRef;
  bsModalRefForError: BsModalRef;
  selectedItem: any;
  gatewayToken:any;
  firstHit: any = 1;
  show: boolean = false;
  orderDetail: any;
  componentLoaded = false;
  allProductCounts: any;
  promotionMessage = [];
  saveCardValue: any;
  global_data:any = {};
  errorMessage = '';
  configDetails = '';
  cardtypes = {'VI': 'Visa', 'AE':'American Express', 'MC':'Mastercard', 'DI':'Discover', 'DN':'Diners Club',
  'JCB':'JCB'}
  cardImages = {'VI': 'vi.svg', 'AE':'ae.svg', 'MC':'mc.svg', 'DI':'di.svg', 'DN':'dn.svg',
  'JCB':'jcb.svg'}
  url: any;
  constructor(private cartService: CartService, private statePersist: StatePersistService,
    private alertService: AlertService, private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router, private titleService: Title,
    private modalService: BsModalService,
    private renderer: Renderer2,
    private el:ElementRef,
    private loaderService: LoaderService, 
    public sanitizer:DomSanitizer, private store:Store<SharedState>) {this.getConfigFromStore() }

  
  getConfigFromStore(){
    const config_store$ = this.store.pipe(select(getConfig));
    config_store$.subscribe(res=>this.configDetails = res)
    }
  newpaymentEvent(){
    document.body.classList.add("saved-payment-box");
    document.body.classList.remove("new-payment-box");
    document.getElementById('savecardpay-button').classList.add('savecard-payment');
    document.getElementById('pay-button').classList.remove('newcard-payment');
}
paymentEvent(){
  document.body.classList.add("new-payment-box");
  document.body.classList.remove("saved-payment-box");
  document.getElementById('pay-button').classList.add('newcard-payment');
  document.getElementById('savecardpay-button').classList.remove('savecard-payment');
}
items: any;

  ngOnInit(): void {
    this.orderDetail = null;
    this.titleService.setTitle(CartModuleConsts.PAYMENT_PAGE_TITLE);
    this.checkoutDetail()
    this.statePersist.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })
    if(Object.keys(this.statePersist.configDetails).length == 0){
      this.statePersist.getConfigStatus.subscribe((response:any)=>{    
        if(response){
          this.setcheckout()
          this.statePersist.isConfigSetoStore.next(false);
          
        }
      })
    }
    else{
      this.setcheckout()
      this.statePersist.isConfigSetoStore.next(false);
    }
      window.scrollTo(0, 0)

  }


  handlePaymentSuccess(paymentResponse: any) {
    console.log('Payment success response received:', paymentResponse);
    const container = document.querySelector('#flow-container');
    
    // Look for the specific element name Checkout.com generates on your screen
    const nativeCheckbox = container?.querySelector('input[name="shouldSaveCardAtMerchant"]') as HTMLInputElement 
                        || container?.querySelector('#shouldSaveCardAtMerchant') as HTMLInputElement;

    // Extract the exact boolean checked choice state (true if checked, false if empty)
    const isSaveCardChecked = nativeCheckbox ? nativeCheckbox.checked : false;

    // Store it inside your class property variable
    this.wantsToSaveCard = isSaveCardChecked;
    console.log(this.wantsToSaveCard)
    const payloadForMagento = {
      paymentMethod: {
        method: "checkout_com_vault",
        additional_data: {
          // Passes the secure reference hash string out of the iframe response
          public_hash: paymentResponse.payment_token || paymentResponse.id,
          
          // Passes your checkbox state value (true or false) straight to your server logs
          save_card: this.wantsToSaveCard 
        }
      }
    };

    console.log('Sending this unified payload configuration to Magento REST API:', JSON.stringify(payloadForMagento));

    this.googleAnalyticsService.eventEmitter(
      SharedConsts.PLACE_ORDER_EVENT,
      SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
      SharedConsts.PLACE_ORDER_EVENT_ACTION,
      SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
      SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
    );
  
    this.router.navigate(['mycart/order-confirmation']);
    this.isPaymentLoading = false;
  }

  flowInstance: any;
//third

async initializeFlow(): Promise<void> {
  try {
    const checkout = await loadCheckoutWebComponents({
      publicKey: this.publicKey,
      environment: 'sandbox', 
      paymentSession: this.paymentSessionId,
      locale: 'en-GB',
      risk: { enabled: false }, // Bypasses sandbox tracker 403 errors
      
      onReady: () => {
        this.isFormRendered = true; // Turn button visibility ON
      },
      
      // 💥 THE HOOK: Natively captures Non-3DS Transaction ID and Date variables
      onPaymentCompleted: (_component: any, response: any) => {
        console.log('🚀 [Non-3DS Hook Success] Payload Captured:', response);
        
        const transactionId = response?.id || response?.payment_token;
        const transactionDate = response?.processed_on || response?.created_on || new Date().toISOString();

        // Ensure the localized order details array has been prepared before mapping
        if (!this.orderDetail) {
          this.orderDetail = {};
        }

        // Complete the configuration object tracking array with Non-3DS payload details
        this.orderDetail["transaction_payment_id"] = transactionId;
        this.orderDetail['transaction_date'] = transactionDate;
        // Save tracking arrays and finalize the route sequence path
        this.statePersist.setLocalStorage('order-detail', this.orderDetail);

        console.log('✅ Final Order Details saved for Non-3DS path:', this.orderDetail);
        if (response?.status !== 'redirect' && !response?.redirect_url) {
          this.router.navigate(['mycart/order-confirmation']);
          this.isPaymentLoading = false;
        }

        
        
      },
      onError: (_component: any, error: any) => {
        if (error?.code === 'component_invalid' || error?.message?.includes('invalid')) {
          this.isPaymentLoading = false;
          return; // Ends the block quietly without showing any alert boxes!
        }
        this.isPaymentLoading = false;
        this.alertService.error(error?.message || 'Payment has been declined.');
      }
    } as any);

    this.checkoutEngine = checkout;

    // Create 'card' component type and natively hide their built-in button footer
    this.cardComponent = checkout.create('card', {
      showPayButton: false ,
    } as any);
    
    
    const isCardAvailable = await this.cardComponent.isAvailable();
    if (isCardAvailable) {
      this.cardComponent.mount('#flow-container');
      console.log('Checkout.com secure card inputs successfully mounted.');
      
    } else {
      this.alertService.error('The checkout form fields are temporarily unavailable.');
    }

    // CRITICAL: Turn loading state OFF so your custom yellow button shows on screen!
    this.isPaymentLoading = false; 

  } catch (error) {
    this.isPaymentLoading = false;
    this.alertService.error('Failed to parse secure payment interface panels.');
  }
}

// 3️⃣ USER FILL DETAILS AND CLICKS YOUR YELLOW BUTTON -> PLACE ORDER -> SUBMIT CARD
submitPayment() {
  if (!this.cardComponent) {
    this.alertService.error('Payment form inputs are not fully ready.');
    return;
  }
 
  if (!this.cardComponent.isValid()) {
    this.cardComponent.submit().catch(() => {}); 
    
    return; // 🔒 HALTS EXECUTION IMMEDIATELY: Magento createOrder() will never be called!
  }

  // Turn loading animation state ON while processing backend data routing loops
  this.loaderService.isLoading.next(true);
  this.isPaymentLoading = true; 
  console.log('Step 1: Custom yellow button clicked. Placing order in Magento backend first...');

  // Extract auto-rendered checkbox choice state dynamically from DOM
  const container = document.querySelector('#flow-container');
  const nativeCheckbox = container?.querySelector('input[name="shouldSaveCardAtMerchant"]') as HTMLInputElement;
  this.wantsToSaveCard = nativeCheckbox ? nativeCheckbox.checked : false;
  var payload = {'save_card':this.wantsToSaveCard, 'website':1}

  // CALL MAGENTO TO CREATE ORDER FIRST WHEN CLICKED
  this.cartService.createOrder(payload).subscribe({
    next: (response: any) => {
      console.log('Step 2: Magento Order created successfully! Order ID Reference:', response);
      
      // Map Magento backend response tokens right away into local memory 
      this.orderDetail['order_id'] = response.response.order_id;
      this.orderDetail['order_date'] = response.response.order_date;
      this.orderDetail['grand_total'] = response.response.grand_total;
      this.orderDetail['price_visibility'] = this.global_data['price_visibility'];
      this.orderDetail['card_payment'] = 1;
      this.statePersist.setLocalStorage('order-detail', this.orderDetail);

      console.log('Step 3: Triggering Checkout.com secure card validation/tokenization event...');
      
      // Order success -> Instantly trigger card submission within the same click thread
      this.cardComponent.submit()
        .then((paymentResponse: any) => {
          console.log('Step 4: Card submission complete. Evaluating potential 3DS redirection pathways...', paymentResponse);
          
          // 🔒 3DS REDIRECT COMPLIANCE HANDSHAKE (Fires ONLY if card is 3DS)
          if (paymentResponse?.status === 'redirect' || paymentResponse?.redirect_url) {
            const secure3DsUrl = paymentResponse.redirect_url || paymentResponse.links?.redirect?.href;
            if (secure3DsUrl) {
              console.log('Card mandates 3DS challenge. Transferring window focus to:', secure3DsUrl);
              
              // Back up the existing Magento details parameters into temporary localStorage 
              // so your 3DS landing handler can retrieve them after returning from the bank
              const transactionId = paymentResponse?.id ;
              const transactionDate = `${new Date().getDate()} ${new Date().toLocaleDateString('en-GB', { month: 'short' })},${new Date().getFullYear()}`;


              // Complete the configuration object tracking array with Non-3DS payload details
              this.orderDetail["transaction_payment_id"] = transactionId;
              this.orderDetail['transaction_date'] = transactionDate;
              this.statePersist.setLocalStorage('order-detail', this.orderDetail);
              
              window.location.href = secure3DsUrl;
              return;
            }
          }
          this.loaderService.isLoading.next(false);
          console.log('Non-3DS card confirmed. Processing handover to onPaymentCompleted interceptor hook...');
        })
        .catch((error: any) => {
          console.error('Checkout.com secure submission failed:', error);
          this.isPaymentLoading = false;
          this.loaderService.isLoading.next(false);
          this.alertService.error(error?.message || 'Card verification tokenization failed.');
        });
    },
    error: (err) => {
      console.error('Magento order placement failed:', err);
      this.alertService.error(err?.message || 'Failed to place order in Magento.');
      this.isPaymentLoading = false;
      this.loaderService.isLoading.next(false);
    }
  });
}

  
  // createMagentoOrderAfterTokenization(paymentResponse: any) {
  //   console.log('Step 2: Sending token payload over to Magento backend API...');

  //   // Extract the state of the auto-rendered checkbox cleanly from the DOM layout container
  //   const container = document.querySelector('#flow-container');
  //   const nativeCheckbox = container?.querySelector('input[name="shouldSaveCardAtMerchant"]') as HTMLInputElement;
  //   this.wantsToSaveCard = nativeCheckbox ? nativeCheckbox.checked : false;

  //   const orderPayload = {
  //     paymentMethod: {
  //       method: "checkout_com_vault", // Set your custom payment gateway method code matching Magento etc configurations
  //       additional_data: {
  //         // Pass the secure token reference hash string out of the checkout response
  //         public_hash: paymentResponse.payment_token || paymentResponse.id,
  //         save_card: this.wantsToSaveCard 
  //       }
  //     }
  //   };

  //   // Call your standard Magento checkout service route to place the order
  //   this.cartService.createOrder().subscribe({
  //     next: (magentoApiResponse: any) => {
  //       console.log('Step 3: Magento backend processed payload successfully!', magentoApiResponse);

  //       // 🔒 3DS REDIRECT RESOLUTION LAYER: Check if the response metadata from Magento mandates a 3DS redirect
  //       if (paymentResponse?.status === 'redirect' || paymentResponse?.redirect_url || magentoApiResponse?.redirect_url) {
  //         const secure3DsUrl = paymentResponse.redirect_url 
  //                           || paymentResponse.links?.redirect?.href 
  //                           || magentoApiResponse?.redirect_url;
          
  //         if (secure3DsUrl) {
  //           window.location.href = secure3DsUrl; // Redirects the browser window to complete verification
  //           return;
  //         }
  //       }

  //       // If no 3DS redirection challenge is triggered, route cleanly to your confirmation view
  //       this.router.navigate(['mycart/order-confirmation']);
  //       this.isPaymentLoading = false;
  //     },
  //     error: (err) => {
  //       console.error('Magento placement failed at backend:', err);
  //       this.alertService.error(err?.message || 'Order creation layout failed at backend endpoint.');
  //       this.isPaymentLoading = false;
  //     }
  //   });
  // }



  setcheckout() {

    const amount = Math.round(
      Number(this.orderDetail?.cart_total?.grand_total) * 100
    );
  
    this.cartService.createPaymentSession().subscribe((response: any) => {
      console.log(response)
      this.paymentSessionId = response.paymentSession;
      this.publicKey = response.publicKey
  
      setTimeout(() => {
        this.initializeFlow();
      }, 200);
  
    });
  
  }


  changeSaveCard(event){
    this.saveCardValue = event.target.checked
  }

  checkoutDetail(){
    this.cartService.checkoutDetail()
    .subscribe(
      response => {
          if (response.status == 2212){
            this.alertService.error(response.response)
          }
          else{
            this.orderDetail = response.response
            this.promotionMessage = this.orderDetail.one_free_withten_msg
            this.show = false;
            if(this.orderDetail.items_count != '0' && this.orderDetail.min_cases == ''){
              this.firstHit = 1
            }
          
          }
          this.cardList()
          
        },
        error => { }
    )
  }

  cardList(){
    this.cartService.savecardList()
    .subscribe(
      response => {
          this.items = []
          if (response.status == 1181){
            console.log()
          }
          else{
            let cardlist, cardNewList = [];
            cardlist = response.response.cardList;
            this.items = []
            for (let i = 0; i < cardlist.length; i++) {
              cardNewList.push({'value':this.cardtypes[cardlist[i]['type']]+', ending: '+cardlist[i]['card_bin']+', expires: '+cardlist[i]['card_expiry_date'],
              'gateway_token':cardlist[i]['gateway_token'], 'image':this.cardImages[cardlist[i]['type']], 'id':cardlist[i]['gateway_token']})
            }       
            this.items = cardNewList
            
            
            window.scroll({ 
              top: 0, 
              left: 0, 
              behavior: 'smooth' 
            });

          }

          setTimeout(() => {
            if (this.items.length > 0){
              this.paymentEvent()
              if(this.items.length == 1){
                this.selectPaymentCard(0, this.items[0])
              }
            }
            else{
              this.newpaymentEvent()
            }
          }, 1000);          
        },
        error => { }
    )
  }

  removeCard(item){
    this.cartService.removeSaveCard({'gateway_token':item.gateway_token})
    .subscribe(
      response => {
        this.items = this.items.filter(olditem => olditem.id !== item.gateway_token);
        this.alertService.success(response.response)
        },
        error => { }
    )
  }

  selectPaymentCard(card_id, item){

    this.selectedItem = card_id;
    this.gatewayToken = item.gateway_token
    document.getElementById('savecardpay-button').removeAttribute("disabled")
  }

  

  detectBrowserName() { 
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }
  placeOrder(flag, token, savecard, errorTemplate, infoTemplate, card_bin){
    let po_number = this.statePersist.getLocalStorage('po_number')
    var popUp
    
    this.cartService.placeOrder('', flag, token, savecard, '', po_number, false, card_bin)
    .subscribe(
      response => {
        if (response.status == 1161 || response.status ==1153 || response.status == 2215){
          popUp.close();
          this.alertService.error(response.response)
          this.router.navigate(['/'])
        }
        else if (response.status == 1182){
          popUp.close();
          this.errorMessage = response.response;
          this.bsModalRefForError = this.modalService.show(errorTemplate,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
          var form = document.getElementById("payment-form");
          (form as HTMLFormElement).reset();
          var data = document.getElementById('singleIframe').getAttribute('src')
          var data1 = document.getElementById('singleIframe')
          this.saveCardValue = false
          data1.setAttribute('src', data+'')
          document.getElementById('pay-button').setAttribute("disabled", 'true')
        }
        else if (response.status == 403){
          if(this.detectBrowserName()=='safari'){
            popUp.close();
              this.router.navigate(['/'])
          }else{
            setTimeout(() => {
              popUp.close();
              this.router.navigate(['/'])
            }, 500);
          }
          
        }
        else if (response.status == 1157){
          popUp.close()
          this.alertService.error(response.response)
          this.router.navigate(['/'])
          document.body.classList.remove("saved-payment-box");
          document.body.classList.remove("new-payment-box");
        }
        else if (response.status == 1180){
          popUp.close()
            localStorage.setItem('closeStorInfoMessage', response.response.msg)
            document.getElementById("openclosedStoreInfo").click();
            this.router.navigate(['/'])
            document.body.classList.remove("saved-payment-box");
            document.body.classList.remove("new-payment-box");
        }
       else  if (response.status == 1170){
          popUp.close()
          this.router.navigate(['/'])
          this.statePersist.emitminiCartData('mini cart update')
          this.statePersist.emitoutOfStockData('out of stock update')
          this.statePersist.emitmobileListCountDetails('mobile count change')
          this.statePersist.emitmyCartData('my cart list update')
          this.statePersist.emitOrderDetailData('updae order Deatil')
          document.body.classList.remove("saved-payment-box");
          document.body.classList.remove("new-payment-box");
        }
        else if (response.status == 1199){
          popUp.location =response.response

        }
        else{
          this.orderDetail['order_id'] = response.response.order_id
          this.orderDetail['order_date'] = response.response.order_date
          this.orderDetail['grand_total'] = response.response.grand_total 
          this.orderDetail["transaction_payment_id"] = response.response.transaction_payment_id 
          this.orderDetail['transaction_date'] = response.response.transaction_date
          this.orderDetail['price_visibility'] = this.global_data['price_visibility']
          this.orderDetail['card_payment'] = 1
          this.statePersist.setLocalStorage('order-detail', this.orderDetail)
          document.body.classList.remove("saved-payment-box");
          document.body.classList.remove("new-payment-box");
          if (response.response.redirect_url != ''){
           this.bsModalRef = this.modalService.show(infoTemplate,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
            popUp.location =response.response.redirect_url
              
           }
          else{
            this.googleAnalyticsService.eventEmitter(SharedConsts.PLACE_ORDER_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PLACE_ORDER_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
            this.router.navigate(['mycart/order-confirmation'])
          }
          
          
        }
        this.firstHit = ''
        
        },
        error => { }
    )
    

  }

  closeInfoPopup(){
    this.bsModalRef.hide()
    this.router.navigate(['mycart'])
  }

  closeErrorPopup(){
    this.bsModalRefForError.hide()
  }

}
